import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var WarningIcon = function WarningIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.294 17.5",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("path", {
    fill: "none",
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#2B5DFF"),
    "stroke-width": "".concat((_d = attrs["stroke-width"]) !== null && _d !== void 0 ? _d : "1"),
    d: "M7.559 1.955 1.106 13.133a2.411 2.411 0 0 0 2.088 3.617H16.1a2.411 2.411 0 0 0 2.088-3.617L11.735 1.955a2.411 2.411 0 0 0-4.176 0Z"
  }), h("path", {
    fill: "".concat((_e = attrs["stroke-color"]) !== null && _e !== void 0 ? _e : "#2B5DFF"),
    d: "M9.647 11.776a.9.9 0 0 1-.9-.9v-5.99a.904.904 0 1 1 1.808 0v5.985a.9.9 0 0 1-.9.9"
  }), h("path", {
    fill: "".concat((_f = attrs["stroke-color"]) !== null && _f !== void 0 ? _f : "#2B5DFF"),
    d: "M8.58 13.528a1.067 1.067 0 1 1 1.067 1.067 1.067 1.067 0 0 1-1.067-1.067"
  })]);
};